export default "__VITE_ASSET__BbbHoXlX__"